module.exports = __webpack_public_path__ + "static/media/bd2.37e5f392.jpg";